import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState = new Array<string>();

export const { thunk: listCompanies, slice: listCompaniesSlice } = getThunkAndSlice<Record<string, never>, typeof initialState>({
	initialState,
	path: "/api/Pricing/ListCompanies",
});
